import {Outlet} from 'react-router-dom';

function MRZView() {
  return <Outlet />;
}

export {MRZView};
